import {ref} from "vue";
import * as _ from "lodash-es";

export const useForm = function () {
  const formRef = ref();
  const validate = function () {
    return new Promise(async function (resolve) {
      const dom = formRef.value;
      if (dom && dom.validate) {
        dom.validate((status) => {
          resolve(status)
        }).catch(function (e) {
          resolve(false);
        });
      } else {
        resolve(false);
      }
    });
  }

  const validateField = function (key) {
    return new Promise(function (resolve) {
      const dom = formRef.value;
      if (dom && dom.validateField) {
        const arrayable = _.compact(_.concat([], key));
        dom.validateField(arrayable, (status) => resolve(status));
      } else {
        resolve(false);
      }
    });
  };

  return {formRef, validate, validateField};
}